import React, {useContext} from 'react'
import {
    useRemoveVehicleMutation,
    useToggleVehicleMutation,
    useUpdateVehicleMutation,
    Vehicle,
    VehicleInput
} from "../../../../generated/graphql";
import {EXPENSE} from "../queries";
import {RESULT} from "../../common/result-chart/queries";
import {message} from "antd";
import {FintoolContext} from "../../../../context/fintool-context";
import {I18nContext} from "../../../../i18n";
import {MESSAGE_DURATION} from "../../../../utils/constants";
import {handle} from "../../../app/app";
import VehicleSingleRowFormView from "./vehicle-single-row-form-view";

interface Props {
    vehicle: Vehicle
}

const VehicleSingleRowFormContainer: React.FC<Props> = ({vehicle}) => {

    const [context] = useContext(FintoolContext)
    const {translate} = useContext(I18nContext);

    const [updateVehicle] = useUpdateVehicleMutation({
            refetchQueries: [
                {query: EXPENSE, variables: {calculationHash: context.calculationHash}},
                {query: RESULT, variables: {calculationHash: context.calculationHash}}
            ]
        }
    )
    const [toggleVehicle] = useToggleVehicleMutation({
            refetchQueries: [
                {query: EXPENSE, variables: {calculationHash: context.calculationHash}},
                {query: RESULT, variables: {calculationHash: context.calculationHash}}
            ]
        }
    )
    const [removeVehicle] = useRemoveVehicleMutation({
            refetchQueries: [
                {query: EXPENSE, variables: {calculationHash: context.calculationHash}},
                {query: RESULT, variables: {calculationHash: context.calculationHash}}
            ]
        }
    )

    const onChange = (values: VehicleInput) => {
        if (!!context.calculationHash) {
            updateVehicle({
                variables: {
                    calculationHash: context.calculationHash,
                    vehicleInput: values
                }
            }).then((result: any) => {
                message.success(translate("common.save.success"), MESSAGE_DURATION)
            }).catch((error: any) => {
                handle(error)
            })
        }
    }

    const onToggle = (vehicleId: string, includeInCalculation: Boolean) => {
        if (!!context.calculationHash) {
            toggleVehicle({
                variables: {
                    calculationHash: context.calculationHash,
                    vehicleId: vehicleId,
                    exclude: !includeInCalculation
                }
            }).then((result: any) => {
                message.success(translate("common.save.success"), MESSAGE_DURATION)
            }).catch((error: any) => {
                handle(error)
            })
        }
    }

    const onRemove = (id: string) => {
        if (!!context.calculationHash) {
            removeVehicle({
                variables: {
                    calculationHash: context.calculationHash,
                    vehicleId: id
                }
            }).then((result: any) => {
                message.success(translate("common.delete.succes"), MESSAGE_DURATION)
            }).catch((error: any) => {
                handle(error)
            })
        }
    }

    return (
        <VehicleSingleRowFormView
            vehicle={vehicle}
            onChangedField={onChange}
            onToggleExclusion={onToggle}
            onRemove={onRemove}
        />
    )
}

export default VehicleSingleRowFormContainer